export const isDesktop = (screenWidth) => screenWidth > 1024
export const isTab = (screenWidth) => screenWidth > 500
export const isPhone = (screenWidth) => screenWidth < 500